import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import Button from "../../components/ui/Button";
import SubTaskForm from "../../components/TaskManagement/forms/SubTaskForm";

const SubtaskEditor = ({ isOpen, onClose, subtask, onSaved }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    weight: 1,
    estimatedHours: "",
    tags: []
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Reset form data when subtask prop changes
      setFormData({
        name: subtask?.name || "",
        description: subtask?.description || "",
        weight: subtask?.defaultWeight || subtask?.weight || 1,
        estimatedHours: subtask?.defaultEstimatedHours || subtask?.estimatedHours || "",
        tags: subtask?.tags || [],
        showDescriptionInTimeReport: subtask?.showDescriptionInTimeReport || false,
        requireDescriptionInTimeReport: subtask?.requireDescriptionInTimeReport || false
      });
    }
  }, [isOpen, subtask]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name?.trim()) {
      alert("Subtask name is required");
      return;
    }

    setSaving(true);

    try {
      const payload = {
        name: formData.name,
        description: formData.description,
        defaultWeight: parseFloat(formData.weight) || 1,
        defaultEstimatedHours: formData.estimatedHours ? parseFloat(formData.estimatedHours) : undefined,
        tags: Array.isArray(formData.tags) 
          ? formData.tags 
          : formData.tags.split(",").map(t => t.trim()).filter(Boolean),
        showDescriptionInTimeReport: formData.showDescriptionInTimeReport || false,
        requireDescriptionInTimeReport: formData.requireDescriptionInTimeReport || false
      };

      if (subtask) {
        await axios.put(`/registry/subtasks/${subtask._id}`, payload);
      } else {
        await axios.post("/registry/subtasks", payload);
      }

      onSaved && onSaved();
      onClose();
    } catch (error) {
      console.error("Error saving subtask:", error);
      alert("Failed to save subtask");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">
            {subtask ? "Edit Subtask" : "New Subtask"}
          </h2>

          <form onSubmit={handleSubmit}>
            <SubTaskForm
              value={formData}
              onChange={setFormData}
              mode="registry"
              showSaveToRegistry={false}
              disabled={saving}
            />

            <div className="flex justify-end gap-2 pt-4 mt-4 border-t">
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit" variant="solid" disabled={saving}>
                {saving ? "Saving..." : "Save"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubtaskEditor;
